module.exports = __webpack_public_path__ + "img/Dantam Hair 26.684940b3.jpg";